<input
  [type]="params?.colDef?.cellDataType || 'text'"
  class="ag-input-field-input ag-text-field-input"
  [class.invalid-cell]="isInvalid"
  [(ngModel)]="cellValue"
  (ngModelChange)="onModelChange()"
/>
